<template>
  <SlotMachine></SlotMachine>
</template>
<script>
import SlotMachine from '@/components/SlotMachine' 
export default {
  components:{
    SlotMachine,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped></style>
